/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geo_Label_South_AmericaInputs */

const bn_geo_label_south_america = /** @type {(inputs: Geo_Label_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দক্ষিণ আমেরিকা`)
};

const de_geo_label_south_america = /** @type {(inputs: Geo_Label_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Südamerika`)
};

const el_geo_label_south_america = /** @type {(inputs: Geo_Label_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Νότια Αμερική`)
};

const en_geo_label_south_america = /** @type {(inputs: Geo_Label_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`South America`)
};

const es_geo_label_south_america = /** @type {(inputs: Geo_Label_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudamerica`)
};

const fr_geo_label_south_america = /** @type {(inputs: Geo_Label_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amérique du Sud`)
};

const hi_geo_label_south_america = /** @type {(inputs: Geo_Label_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दक्षिण अमेरिका`)
};

const hu_geo_label_south_america = /** @type {(inputs: Geo_Label_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dél-Amerika`)
};

const id_geo_label_south_america = /** @type {(inputs: Geo_Label_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amerika Selatan`)
};

const it_geo_label_south_america = /** @type {(inputs: Geo_Label_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sud America`)
};

const ja_geo_label_south_america = /** @type {(inputs: Geo_Label_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`南アメリカ`)
};

const ko_geo_label_south_america = /** @type {(inputs: Geo_Label_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`남아메리카`)
};

const nl_geo_label_south_america = /** @type {(inputs: Geo_Label_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuid-Amerika`)
};

const pl_geo_label_south_america = /** @type {(inputs: Geo_Label_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ameryka Południowa`)
};

const pt_geo_label_south_america = /** @type {(inputs: Geo_Label_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ámérica do Sul`)
};

const ru_geo_label_south_america = /** @type {(inputs: Geo_Label_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Южная Америка`)
};

const sv_geo_label_south_america = /** @type {(inputs: Geo_Label_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sydamerika`)
};

const tr_geo_label_south_america = /** @type {(inputs: Geo_Label_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güney Amerika`)
};

const uk_geo_label_south_america = /** @type {(inputs: Geo_Label_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Південна Америка`)
};

const vi_geo_label_south_america = /** @type {(inputs: Geo_Label_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nam Mỹ`)
};

const zh_geo_label_south_america = /** @type {(inputs: Geo_Label_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`南美洲`)
};

const zh_hant_geo_label_south_america = /** @type {(inputs: Geo_Label_South_AmericaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`南美洲`)
};

/**
* | output |
* | --- |
* | "South America" |
*
* @param {Geo_Label_South_AmericaInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const geo_label_south_america = /** @type {((inputs?: Geo_Label_South_AmericaInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geo_Label_South_AmericaInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_geo_label_south_america(inputs)
	if (locale === "de") return de_geo_label_south_america(inputs)
	if (locale === "el") return el_geo_label_south_america(inputs)
	if (locale === "en") return en_geo_label_south_america(inputs)
	if (locale === "es") return es_geo_label_south_america(inputs)
	if (locale === "fr") return fr_geo_label_south_america(inputs)
	if (locale === "hi") return hi_geo_label_south_america(inputs)
	if (locale === "hu") return hu_geo_label_south_america(inputs)
	if (locale === "id") return id_geo_label_south_america(inputs)
	if (locale === "it") return it_geo_label_south_america(inputs)
	if (locale === "ja") return ja_geo_label_south_america(inputs)
	if (locale === "ko") return ko_geo_label_south_america(inputs)
	if (locale === "nl") return nl_geo_label_south_america(inputs)
	if (locale === "pl") return pl_geo_label_south_america(inputs)
	if (locale === "pt") return pt_geo_label_south_america(inputs)
	if (locale === "ru") return ru_geo_label_south_america(inputs)
	if (locale === "sv") return sv_geo_label_south_america(inputs)
	if (locale === "tr") return tr_geo_label_south_america(inputs)
	if (locale === "uk") return uk_geo_label_south_america(inputs)
	if (locale === "vi") return vi_geo_label_south_america(inputs)
	if (locale === "zh") return zh_geo_label_south_america(inputs)
	return zh_hant_geo_label_south_america(inputs)
});